// Module
var code = " <div ng-if=\"vm.showButton()\" class=\"dv-login-button\"> <button class=\"dv-btn\" href=\"\" ui-sref-active=\"active\" ui-sref=\"authentication.login\" data-test=\"login\" translate> LOGIN </button> </div> ";
// Exports
module.exports = code;